import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Truck } from '../models/truck.model';

@Injectable({
  providedIn: 'root',
})
export class TrucksService {
  private mockTrucks: Truck[] = [
    {
      Id: 1,
      Name: 'Truck1',
      FuelType: 'Diesel',
      NumberOfAxis: 2,
    },
    {
      Id: 2,
      Name: 'Truck2',
      FuelType: 'Gas',
      NumberOfAxis: 3,
    },
    {
      Id: 3,
      Name: 'Truck3',
      FuelType: 'Diesel',
      NumberOfAxis: 3,
    },
    {
      Id: 4,
      Name: 'Truck4',
      FuelType: 'Diesel',
      NumberOfAxis: 1,
    },
    {
      Id: 5,
      Name: 'Truck5',
      FuelType: 'Eletric',
      NumberOfAxis: 1,
    },
  ];

  getTrucks(): Observable<Truck[]> {
    return of(this.mockTrucks);
  }

  getById(id: number): Truck {
    const truck = this.mockTrucks.find((x) => x.Id === id);

    if (truck) {
      return truck;
    }
    return {} as Truck;
  }

  setTruck(truck: Truck): void {
    const truckIndex = this.mockTrucks.findIndex((x) => x.Id === truck.Id);
    this.mockTrucks[truckIndex] = truck;
  }

  createTruck(): number {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    const newTruckId = this.mockTrucks.at(-1)?.Id ?? 0 + 1;

    this.mockTrucks.push({
      Id: newTruckId,
      Name: `New Truck ${newTruckId}`,
      FuelType: '',
      NumberOfAxis: 1,
    });

    return newTruckId;
  }
}
